import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EncuestaComponent } from '../encuesta/encuesta.component';
import { Denunciante } from 'src/app/models/Denunciante';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';

@Component({
  selector: 'app-modal-encuesta',
  templateUrl: './modal-encuesta.component.html',
  styleUrls: ['./modal-encuesta.component.css']
})
export class ModalEncuestaComponent implements OnInit {

  @ViewChild(EncuestaComponent) encuestaC: EncuestaComponent;
  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(private dialogRef: MatDialogRef<ModalEncuestaComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Denunciante, ) { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2('Información General');

    setTimeout(() => {

      this.encuestaC.setEncuestaDenunciante(this.data);

    }, 1);

  }

  // _agregarEncuesta()
  // {

  //   var denunciante = this.encuestaC._getEncuestaDenunciante();

  //   //var vFlgError = ;

  //   if(this.encuestaC.validarDatosEncuesta())
  //   {

  //     return;

  //   }

  //   this.dialogRef.close(denunciante);

  // }

  _cancelar() {

    this.dialogRef.close();

  }

}
